import React from "react";
import Sketch from "react-p5";

import './P5Canvas.scss'
// import p5 from "p5";


const P5Canvas = (props) => {

    var ScrollCounter = 0;
    var shapesMaxNumber = 5;
    var step = 45;
    let wheel = 0;
    let shapes = [];

    var time;

    var totalTime = 0.5;


    var LineColor;
    var PlaneColor;
    var LineColorB;
    var BoxColor = {};
    var timeRemaining;


    let grid;
    let cross;

    let opa = 255;
    // let opaVal = 1;



    const setup = (p5, canvasParentRef) => {
        // use parent to render the canvas in this ref
        // (without that p5 will render the canvas outside of your component)
        p5.createCanvas(window.innerWidth*.99, window.innerHeight).parent(canvasParentRef);
        // cnv.mouseClicked(dothings());
        // var objects = {
        //     box: [],
        //     planes:  [],
        //     arc:  []
        // };




        getShapes(p5)
    };


    class Box {
        constructor(x, y, sizeX, sizeY, angle, color, shadow, ceiling) {
            this.sizeX = sizeX;
            this.sizeY = sizeY;
            this.x = x;
            this.y = y;
            this.angle = angle;
            this.color = color;
            this.shadow = shadow;
            this.ceiling = ceiling;
        }
        display(timeRemaining, p5) {
            p5.push();
            p5.noStroke();
            p5.fill(this.shadow, 10);
            p5.beginShape();
            this.sizeY = this.sizeY + p5.sin(timeRemaining) * 0.9;
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.vertex(this.x, this.y + this.sizeY);
            p5.endShape();
            p5.pop();

            p5.push();
            p5.fill(this.color, 10);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + 2 * this.sizeX, this.y + this.sizeY);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.endShape(p5.CLOSE);
            p5.pop();


            p5.push();
            p5.fill(this.ceiling, 10);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + this.sizeX, this.y - p5.tan(this.angle) * this.sizeX);
            p5.endShape(p5.CLOSE);
            p5.pop();
        }


    }
    class Lines {
        constructor(x, y, sizeX, sizeY, angle, color, shadow, ceiling) {
            this.sizeX = sizeX;
            this.sizeY = sizeY;
            this.x = x;
            this.y = y;
            this.angle = angle;
            this.color = color;
            this.shadow = shadow;
            this.ceiling = ceiling;
        }
        display(time, p5) {

            // rotate(radians(-40));

            p5.push();
            p5.noStroke();
            p5.fill(this.shadow);
            p5.beginShape();
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.vertex(this.x, this.y + this.sizeY);
            p5.endShape();
            p5.pop();

            p5.push();
            p5.fill(this.color, 40);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + 2 * this.sizeX, this.y + this.sizeY);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.endShape(p5.CLOSE);
            p5.pop();


            p5.push();
            p5.fill(this.ceiling);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + this.sizeX, this.y - p5.tan(this.angle) * this.sizeX);
            p5.endShape(p5.CLOSE);
            p5.pop();

        }
    }
    class Grid {
        constructor(X, Y, spaceX, spaceY) {
            this.X = X;
            this.Y = Y;
            this.spaceX = spaceX;
            this.spaceY = spaceY;
        }
        display(p5) {
            p5.strokeWeight(1);
            p5.stroke(0);
            p5.beginShape(p5.POINTS);
            for (let i = 0; i < this.X; i += this.spaceX) {
                for (let y = 0; y < this.Y; y += this.spaceY) {
                    p5.vertex(i, y);
                }
            }
            p5.endShape();
        }
    }

    // class BAUText {
    //     constructor(text, x, y, size, color, font) {
    //         this.x = x;
    //         this.y = y;
    //         this.size = size;
    //         this.color = color;
    //         this.font = font;
    //         this.text = text;
    //     }
    //     display(timer) {
    //         p5.textSize(this.size);
    //         p5.textAlign(p5.LEFT, p5.LEFT);
    //         p5.textFont(this.font);
    //         p5.stroke(1)
    //         p5.fill(this.color);
    //         p5.text(this.text, this.x, this.y);
    //         p5.textSize(this.size * .7)
    //         p5.text(timer, this.x, this.y + 25 - Math.p5.sin(timer * 2) * 10)
    //     }

    // }
    class Cross {
        constructor(X, Y, space, size, stroke) {
            this.X = X;
            this.Y = Y;
            this.space = space;
            this.size = size;
            this.stroke = stroke;
        }
        display(p5) {
            p5.stroke(0);
            p5.strokeWeight(this.stroke);
            for (let i = 20; i < this.X; i += this.space) {
                for (let y = 20; y < this.Y; y += this.space) {
                    p5.line(i, y, i + this.size / 2, y);
                    p5.line(i, y, i, y + this.size / 2);
                    p5.line(i, y, i - this.size / 2, y);
                    p5.line(i, y, i, y - this.size / 2);
                }
            }


        }
    }
    class Planes {
        constructor(x, y, sizeX, sizeY, angle, color, shadow, ceiling) {
            this.sizeX = sizeX;
            this.sizeY = sizeY;
            this.x = x;
            this.y = y;
            this.angle = angle;
            this.color = color;
            this.shadow = shadow;
            this.ceiling = ceiling;
        }
        display(time, p5) {

            this.sizeY = this.sizeY + p5.sin(time * 3) * 0.5;
            p5.push();
            p5.noStroke();
            p5.fill(this.shadow);
            p5.beginShape();
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.vertex(this.x, this.y + this.sizeY);
            p5.endShape();
            p5.pop();

            p5.push();
            p5.fill(this.color);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + 2 * this.sizeX, this.y + this.sizeY);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX + this.sizeY);
            p5.endShape(p5.CLOSE);
            p5.pop();


            p5.push();
            p5.fill(this.ceiling);
            p5.noStroke();
            p5.beginShape();
            p5.vertex(this.x, this.y);
            p5.vertex(this.x + this.sizeX, this.y + p5.tan(this.angle) * this.sizeX);
            p5.vertex(this.x + 2 * this.sizeX, this.y);
            p5.vertex(this.x + this.sizeX, this.y - p5.tan(this.angle) * this.sizeX);
            p5.endShape(p5.CLOSE);
            p5.pop();
        }
    }


    class Arcs {
        constructor(Cx, Cy, radius, Sangle, Eangle, height) {
            this.Cx = Cx;
            this.Cy = Cy;
            this.r = radius;
            this.Sangle = Sangle;
            //   this.x;
            //   this.y;
            this.height = height;
            this.Eangle = Eangle;
        }
        display(time, p5) {

            this.height = this.height + Math.sin(time * 2) * .4;
            p5.push();
            p5.noStroke();
            p5.beginShape();
            p5.fill(190, 180, 23);

            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI), this.Cy - this.height + this.r * p5.cos(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(-10) / 2 * p5.PI), this.Cy - this.height + this.r * p5.cos(p5.PI * 2 * p5.radians(-10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(-10) / 2 * p5.PI), this.Cy + this.r * p5.cos(p5.PI * 2 * p5.radians(-10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI), this.Cy + this.r * p5.cos(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI));
            p5.endShape(p5.CLOSE);
            p5.pop();

            p5.push();
            p5.fill(190, 180, 23);
            p5.noStroke();
            p5.beginShape();
            for (step = this.Sangle; step > this.Eangle; step--) {
                this.x = this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(step / 10) / 2 * p5.PI);
                this.y = this.Cy + this.r * p5.cos(p5.PI * 2 * p5.radians(step / 10) / 2 * p5.PI);
                p5.vertex(this.x, this.y);
            };
            p5.endShape();
            p5.pop();

            p5.push();
            p5.fill(255, 222, 23);
            p5.noStroke();
            p5.beginShape();
            for (step = this.Sangle; step > this.Eangle; step--) {
                this.x = this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(step / 10) / 2 * p5.PI);
                this.y = this.Cy - this.height + this.r * p5.cos(p5.PI * 2 * p5.radians(step / 10) / 2 * p5.PI);
                p5.vertex(this.x, this.y);
            };
            p5.endShape();
            p5.pop();




            p5.push();
            p5.noStroke();
            p5.beginShape();
            p5.fill(210, 200, 23);
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI), this.Cy - this.height + this.r * p5.cos(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(145 / 10) / 2 * p5.PI), this.Cy - this.height + this.r * p5.cos(p5.PI * 2 * p5.radians(145 / 10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(145 / 10) / 2 * p5.PI), this.Cy + this.r * p5.cos(p5.PI * 2 * p5.radians(145 / 10) / 2 * p5.PI));
            p5.vertex(this.Cx + this.r * p5.sin(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI), this.Cy + this.r * p5.cos(p5.PI * 2 * p5.radians(this.Sangle / 10) / 2 * p5.PI));
            p5.endShape(p5.CLOSE);
            p5.pop();


        }
    }
    function getShapes(p5) {

        BoxColor = {
            // solid: p5.color(150, 20, 25, opa),
            // shadow: p5.color(80, 10, 15, opa),
            // ceiling: p5.color(190, 30, 45, opa)

            solid: p5.color(224, 222, 222),
            shadow: p5.color(176, 176, 176),
            ceiling: p5.color(252, 252, 252)
        };

        PlaneColor = {
            solid: p5.color(224, 222, 222),
            shadow: p5.color(176, 176, 176),
            ceiling: p5.color(252, 252, 252)
        };

        LineColor = {
            solid: p5.color(224, 222, 222),
            shadow: p5.color(176, 176, 176),
            ceiling: p5.color(252, 252, 252)
        };

        LineColorB = {
            solid: p5.color(224, 222, 222),
            shadow: p5.color(176, 176, 176),
            ceiling: p5.color(252, 252, 252)
        };


        var randomPosX = p5.random(p5.windowWidth * 0.2, p5.windowWidth / 3);
        var randomPosY = p5.random(p5.windowHeight * 0.2, p5.windowHeight * 0.8);
        for (let i = 0; i < 1; i++) {
            if (p5.millis() / 1000 > 35) {
                randomPosX = p5.random(p5.windowWidth / 2, p5.windowWidth * 0.8);
                randomPosY = p5.random(p5.windowHeight * 0.2, p5.windowHeight * 0.8);

            }

            if (p5.millis() / 1000 > 70) {
                randomPosX = p5.random(p5.windowWidth * 0.2, p5.windowWidth / 3);
                randomPosY = p5.random(p5.windowHeight * 0.2, p5.windowHeight * 0.8);

            }

            if (p5.millis() / 1000 > 105) {
                randomPosX = p5.random(p5.windowWidth / 2, p5.windowWidth * 0.8);
                randomPosY = p5.random(p5.windowHeight * 0.2, p5.windowHeight * 0.8);

            }

            let lines = new Lines(randomPosX, randomPosY, p5.random(5, 10), p5.random(100, 400), p5.radians(40), LineColor.solid, LineColor.shadow, LineColor.ceiling);  ////x, y, sizeX, sizeY, angle, color, shadow, ceiling
            let linesb = new Lines(randomPosX, randomPosY, p5.random(5, 10), p5.random(100, 400), p5.radians(40), LineColorB.solid, LineColorB.shadow, LineColorB.ceiling);  ////x, y, sizeX, sizeY, angle, color, shadow, ceiling
            let planes = new Planes(randomPosX, randomPosY, p5.random(5, 200), p5.random(5, 10), p5.radians(40), PlaneColor.solid, PlaneColor.shadow, PlaneColor.ceiling);
            let arc = new Arcs(randomPosX, randomPosY, p5.random(20, 100), 300, 144, p5.random(40, 200));
            let box = new Box(randomPosX, randomPosY, p5.random(20, 100), p5.random(20, 200), p5.radians(40), BoxColor.solid, BoxColor.shadow, BoxColor.ceiling);
            let shapeTypes = [arc, box, planes, lines, linesb];
            let nextShape = shapeTypes[p5.int(p5.random(0, 5))];
            shapes.push(nextShape); //x, y, sizeX, sizeY, angle, color, shadow, ceiling
        }

    }

    // function redrawText() {
    //     // var randomPosX = p5.windowWidth * 0.7;fre
    //     // var randomPosY = p5.windowHeight * 0.8;
    //     // const dataLength = Object.keys(Baudata).length;

    //     // randomNum = Math.floor(Math.random(0, 80));

    //     // var Fonts = { Albers, Bayer, JoostStencil, JoostLight, Futura };
    //     // let SplitDates = "15";


    //     // BAUname.push(new BAUText(Baudata[randomNum].name, randomPosX, randomPosY, TextSizeName, 'black', Fonts[Fontnames[p5.int(p5.random(0, 2))]]));

    //     // BAUdate.push(new BAUText(SplitDates[randomNum], randomPosX, randomPosY * TextSizeDate + 30, TextSizeDate, 'black', Fonts[Fontnames[p5.int(p5.random(0, 2))]])); //
    //     // var Title = Baudata[randomNum].name;
    // }

    // const mousePressed = (p5) => {
    //     getShapes(p5);
    //     step = step + 1;
    // }

    const mouseMoved = (p5) => {
        shapesMaxNumber = 5;
        drawShapesMouse(p5)
    }

    const mouseDragged = (p5) => {
        shapesMaxNumber = 100;
        if (shapes != null) { drawShapesMouse(p5) }

    }

    const windowResized = (p5) => {
        p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
    }

    function drawShapesMouse(p5) {
        var randomPosX = p5.mouseX//random(windowWidth * 0.2, windowWidth * 0.8);
        var randomPosY = p5.mouseY// random(windowHeight * 0.2, windowHeight * 0.8);
        if (PlaneColor) {
            let planes = new Planes(randomPosX, randomPosY, p5.random(5, 200), p5.random(5, 10), p5.radians(40), PlaneColor.solid, PlaneColor.shadow, PlaneColor.ceiling);
            let arc = new Arcs(randomPosX, randomPosY, p5.random(20, 100), 300, 144, p5.random(40, 200));
            let box = new Box(randomPosX, randomPosY, p5.random(20, 100), p5.random(20, 200), p5.radians(40), BoxColor.solid, BoxColor.shadow, BoxColor.ceiling);
            let shapeTypes = [arc, box, planes];
            let nextShape = shapeTypes[p5.int(p5.random(0, 3))];
            nextShape.display(time, p5)
            shapes.push(nextShape); //x, y, sizeX, sizeY, angle, color, shadow, ceiling
        }
    }

    const draw = (p5) => {
        p5.background(255, 255, 255);

        if (shapes) {
            redrawGrid(p5);



            time = (p5.millis() / 1000).toFixed(2);
            timeRemaining = (totalTime - time).toFixed(2);




            // redrawText();
            if (time % 1 == 0) { getShapes(p5); }

            // Have to fix continous shape pushing when unfocused

            p5.push();
            for (let i = 0; i < shapes.length; i++) {
                shapes[i].display(time, p5);
            }

            p5.pop();

        }
        else {

        }

        if (shapes.length > shapesMaxNumber) {
            shapes.shift();
        }

    };

    function redrawGrid(p5) {
        grid = new Grid(p5.windowWidth, p5.windowHeight, 20, 20);      // X, Y, spaceX, spaceY
        cross = new Cross(p5.windowWidth, p5.windowHeight, 80, 20, 2);  // X, Y, space, size, stroke

        grid.spaceX = 20;
        grid.display(p5);
        cross.size = 5;
        cross.stroke = 1;
        cross.display(p5);
    }

    return (
        <div className='P5Canvas'>
            <Sketch setup={setup} draw={draw} mouseMoved={mouseMoved} mouseDragged={mouseDragged} windowResized={windowResized}  />
        </div>
    )
};

export default P5Canvas